import React, { useEffect, useState } from "react";
import {
  Badge,
  Button,
  Card,
  Col,
  Container,
  FloatingLabel,
  Form,
  Image,
  ListGroup,
  OverlayTrigger,
  ProgressBar,
  Row,
  Spinner,
  Tooltip,
  Modal,
} from "react-bootstrap";
import dayjs from "dayjs";
import { UseConsultant } from "../context/ConsultantContext";
import { vasthuUrl } from "./Api";
import { useTranslation } from "react-i18next";
import Toast from "./Toast";
import { format, parse } from "date-fns";
import DatePicker from "react-date-picker";
import { TimePicker } from "antd";
import { FaFemale, FaMale } from "react-icons/fa";

function UserDetailModal({ userDetailsModal }) {
  const { handleChat, handleFreeChat } = UseConsultant();
  const { t } = useTranslation();
  const userId = window.sessionStorage.getItem("userId");
  const token = window.sessionStorage.getItem("token");
  const [saveMatchingDetailes, setSaveMatchingDetailes] = useState();
  const [savePersonalDetailes, setSavePersonalDetailes] = useState();
  const [showForm, setShowForm] = useState(false);
  const [showFemaleForm, setShowFemaleForm] = useState(false);
  const [singleForm, setSingleForm] = useState(false);
  const [showAddMaleButton, setShowAddMaleButton] = useState(true);
  const [showAddFemaleButton, setShowAddFemaleButton] = useState(true);

  // ALERT MODAL
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");
  const [toastTrigger, setToastTrigger] = useState(0);

  const alert = (msg, type) => {
    setMessage(msg);
    setMessageType(type);
    setToastTrigger((prev) => prev + 1);
  };

  const [chatUserDetailsModel, setChatUserDetailsModel] = useState(false);

  const openUserDetailModal = () => {
    setChatUserDetailsModel(true);
  };

  const handleUserDetailesCloseModel = () => {
    setMaleSelectedCard(null);
    setFemaleSelectedCard(null);
    setSingleSelectedCard(null);
    setSingleForm(null);
    setShowForm(null);
    setShowFemaleForm(null);
    setSelectedOption("Personal");
    setChatUserDetailsModel(false);
  };

  //Personal Consultation Details
  const [userName, setUserName] = useState();
  const [userPlace, setUserPlace] = useState();
  const [dateValue, setDateValue] = useState();
  console.log("dateValue", dateValue);
  const [timeValue, setTimeValue] = useState(null);
  const [selectedOption, setSelectedOption] = useState("Personal");
  const [gender, setGender] = useState("male");
  console.log("gender", gender);

  //Female Matching Details
  const [feuserName, setFeUserName] = useState();
  const [feuserPlace, setFeUserPlace] = useState();
  const [fedateValue, setFeDateValue] = useState();
  const [fetimeValue, setFeTimeValue] = useState(null);

  const handleDateChange = (date) => {
    setDateValue(date);
    setTimeValue(null);
  };

  const handleTimeChange = (key, time) => {
    const newTime = time ? dayjs(time) : null;

    if (key === "general") {
      setTimeValue(newTime);
    } else if (key === "male") {
      setMaleTimeValue(time ? time.format("hh:mm A") : null);
    } else if (key === "female") {
      setFeTimeValue(newTime);
    }
  };

  const getDisabledHours = () => {
    if (dateValue && isToday(dateValue)) {
      const currentHour = new Date().getHours();
      return Array.from({ length: 24 }, (_, i) =>
        i > currentHour ? i : null
      ).filter(Number.isInteger);
    }
    return [];
  };

  const isToday = (someDate) => {
    if (!someDate || !(someDate instanceof Date) || isNaN(someDate)) {
      return false;
    }
    const today = new Date();
    return (
      someDate.getDate() === today.getDate() &&
      someDate.getMonth() === today.getMonth() &&
      someDate.getFullYear() === today.getFullYear()
    );
  };

  const getDisabledMinutes = (selectedHour) => {
    if (dateValue && isToday(dateValue)) {
      const currentDate = new Date();
      const currentHour = currentDate.getHours();
      if (selectedHour === currentHour) {
        const currentMinute = currentDate.getMinutes();
        return Array.from({ length: 60 }, (_, i) =>
          i > currentMinute ? i : null
        ).filter(Number.isInteger);
      }
    }
    return [];
  };

  //Male Matching Details
  const [maleUserName, setMaleUserName] = useState();
  const [maleuserPlace, setMaleUserPlace] = useState();
  const [maledateValue, setMaleDateValue] = useState();
  const [maletimeValue, setMaleTimeValue] = useState(null);
  console.log("maletimeValue", maletimeValue);
  console.log("fetimeValue", fetimeValue);
  const [maleselectedCard, setMaleSelectedCard] = useState(null);
  const [femaleSelectedCard, setFemaleSelectedCard] = useState(null);
  const [singleSelectedCard, setSingleSelectedCard] = useState(null);
  console.log("singleSelectedCard", singleSelectedCard);
  console.log("maleselectedCard", maleselectedCard);
  console.log("femaleSelectedCard", femaleSelectedCard);

  const handleSelection = (user, gender) => {
    console.log("Selected Gender:", gender);
    console.log("User Object:", user);

    if (gender === "male") {
      setMaleSelectedCard({
        name: user.maleUserName,
        birthDate: user.maleBirthDate,
        birthTime: user.maleBirthTime,
        birthPlace: user.maleBirthPlace,
        useExisting: true,
      });
      setShowAddMaleButton(false);
      setMaleUserName(user.maleUserName);
      setMaleDateValue(user.maleBirthDate);
      setMaleTimeValue(user.maleBirthTime);
      setMaleUserPlace(user.maleBirthPlace);
    } else if (gender === "female") {
      setFemaleSelectedCard({
        name: user.femaleUserName,
        birthDate: user.femaleBirthDate,
        birthTime: user.femaleBirthTime,
        birthPlace: user.femaleBirthPlace,
        useExisting: true,
      });

      setFeUserName(user.femaleUserName);
      setFeDateValue(user.femaleBirthDate);
      setFeTimeValue(user.femaleBirthTime);
      setFeUserPlace(user.femaleBirthPlace);
    } else if (gender === "single") {
      setSingleSelectedCard({
        name: user.userName,
        birthDate: user.birthDate,
        birthTime: user.birthTime,
        birthPlace: user.userBirthstate,
        useExisting: true,
      });

      setUserName(user.userName);
      setDateValue(user.birthDate);
      setTimeValue(user.birthTime);
      setUserPlace(user.userBirthstate);
    }
  };

  useEffect(() => {
    console.log(
      "Selected Male User Details:",
      maleselectedCard,
      singleSelectedCard,
      femaleSelectedCard
    );
  }, [maleselectedCard, singleSelectedCard, femaleSelectedCard]);

  console.log("maleselectedCard", maleselectedCard);
  console.log("femaleSelectedCard", femaleSelectedCard);

  const handleMaleDateChange = (date) => {
    setMaleDateValue(date);
    setMaleTimeValue(null);
  };

  useEffect(() => {
    if (userId !== null) {
      try {
        vasthuUrl
          .get(`getAstroDetailsFormatching/${userId}`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })
          .then((res) => {
            console.log("users", res.data);
            // const data = res.data;
            // if (data.length > 0) {
            if (res.data.message == "NOT A VALID USER") {
              setShowForm(true);
              setShowFemaleForm(true);
            } else {
              setSaveMatchingDetailes(res.data);
            }
          });
      } catch (e) {
        alert("SERVER ERROR");
      }
      try {
        vasthuUrl
          .get(`getAstroPersonalDetails/${userId}`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })
          .then((res) => {
            console.log("users", res.data);
            // const data = res.data;
            // if (data.length > 0) {
            if (res.data.message == "NOT A VALID USER") {
              setSingleForm(true);
            } else {
              setSavePersonalDetailes(res.data);
            }
          });
      } catch (e) {
        alert("SERVER ERROR");
      }
    }
  }, []);

  const handleFemaleDateChange = (date) => {
    console.log("date", date);
    setFeDateValue(date);
    setFeTimeValue(null);
  };

  console.log("fedateValue", fedateValue);
  console.log("fetimeValue", fetimeValue);

  const handleAddMatchingDetailes = (isExisting) => {
    if (!maleUserName && !feuserName) {
      alert("Please select any one pair or add male/female to submit");
      setMessageType("error");
      return;
    }
    if (!maleUserName) {
      alert("Please enter your male name.");
      setMessageType("error");
      return;
    }
    if (!maledateValue) {
      alert("Please enter your male birth date.");
      setMessageType("error");
      return;
    }
    if (!maletimeValue) {
      alert("Please enter your male birth time.");
      setMessageType("error");
      return;
    }
    if (!maleuserPlace) {
      alert("Please enter your male birth place.");
      setMessageType("error");
      return;
    }
    if (!feuserName) {
      alert("Please enter Female your name.");
      setMessageType("error");
      return;
    }
    if (!fedateValue) {
      alert("Please enter your Female birth date.");
      setMessageType("error");
      return;
    }
    if (!fetimeValue) {
      alert("Please enter your Female birth time.");
      setMessageType("error");
      return;
    }
    if (!feuserPlace) {
      alert("Please enter your Female birth place.");
      setMessageType("error");
      return;
    }
    console.log("handleAddMatchingDetailes called!");
    const consultantuuiId = window.sessionStorage.getItem("consultantId");
    setChatUserDetailsModel(false);
    console.log("consultantuuiId from sessionStorage:", consultantuuiId);
    AddMatchingDetailes(isExisting, consultantuuiId);
  };

  const AddMatchingDetailes = async (isExisting, consultantuuiId) => {
    console.log("Function AddMatchingDetailes started...");
    const formattedMaleTime =
      maletimeValue && dayjs(maletimeValue, ["HH:mm", "hh:mm A"]).isValid()
        ? dayjs(maletimeValue, ["HH:mm", "hh:mm A"]).format("HH:mm:ss")
        : "00:00:00";

    const formattedFemaleTime =
      fetimeValue && dayjs(fetimeValue, ["HH:mm", "hh:mm A"]).isValid()
        ? dayjs(fetimeValue, ["HH:mm", "hh:mm A"]).format("HH:mm:ss")
        : "00:00:00";

    console.log("Formatted maleBirthTime:", formattedMaleTime);
    console.log("Formatted femaleBirthTime:", formattedFemaleTime);

    // Ensure male and female date values exist before formatting
    const finalMaleDateValue = maledateValue
      ? dayjs(maledateValue).format("YYYY-MM-DD")
      : maleselectedCard.maleBirthDate
      ? dayjs(maleselectedCard.maleBirthDate).format("YYYY-MM-DD")
      : null;

    const finalFeDateValue = fedateValue
      ? dayjs(fedateValue).format("YYYY-MM-DD")
      : femaleSelectedCard.femaleBirthDate
      ? dayjs(femaleSelectedCard.femaleBirthDate).format("YYYY-MM-DD")
      : null;

    console.log("Formatted maleBirthDate:", finalMaleDateValue);
    console.log("Formatted femaleBirthDate:", finalFeDateValue);

    console.log("Sending data:", {
      userId,
      to_Id: consultantuuiId,
      maleUserName,
      femaleUserName: feuserName,
      maleBirthDate: finalMaleDateValue,
      femaleBirthDate: finalFeDateValue,
      maleBirthPlace: maleuserPlace,
      femaleBirthPlace: feuserPlace,
      maleBirthTime: formattedMaleTime,
      femaleBirthTime: formattedFemaleTime,
      useExistingMale: Boolean(isExisting),
      useExistingFemale: Boolean(isExisting),
    });

    try {
      if (!maleUserName || !maleuserPlace || !feuserName || !feuserPlace) {
        console.error("Missing required fields!");
        alert("Please enter all details");
        return;
      }

      console.log("Making API request...");
      const res = await vasthuUrl.post(
        `astroCustomerDetailsForMatching`,
        {
          userId: userId,
          to_Id: consultantuuiId,
          maleUserName: maleUserName,
          femaleUserName: feuserName,
          maleBirthDate: finalMaleDateValue,
          femaleBirthDate: finalFeDateValue,
          maleBirthPlace: maleuserPlace,
          femaleBirthPlace: feuserPlace,
          maleBirthTime: formattedMaleTime,
          femaleBirthTime: formattedFemaleTime,
          useExistingMale: Boolean(isExisting),
          useExistingFemale: Boolean(isExisting),
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      console.log("API response:", res.data);
      alert(res.data.message);
      setMessageType("success");
      alert("Successfully Uploaded Your Details!");
      startCountdown();
    } catch (error) {
      console.error("Error saving details:", error);
      alert("An error occurred while saving details.");
    }
  };

  const handleButtonClick = (useExisting) => {
    if (!userName) {
      alert("Please enter your name.");
      setMessageType("error");
      return;
    }
    if (!dateValue) {
      alert("Please enter your birth date.");
      setMessageType("error");
      return;
    }
    if (!timeValue) {
      alert("Please enter your birth time.");
      setMessageType("error");
      return;
    }
    if (!userPlace) {
      alert("Please enter your birth place.");
      setMessageType("error");
      return;
    }
    const consultantuuiId = window.sessionStorage.getItem("consultantId");
    setChatUserDetailsModel(false);
    addPersonalConsultationDetails(consultantuuiId, useExisting);
  };

  const addPersonalConsultationDetails = async (
    consultantuuiId,
    useExisting
  ) => {
    const finalUserName = userName || singleSelectedCard.name;
    const finalDateValue = dateValue || singleSelectedCard.birthDate;
    const finalTimeValue = timeValue
      ? dayjs(timeValue, "HH:mm:ss").format("HH:mm:ss")
      : singleSelectedCard.birthTime || "00:00:00";
    const finalUserPlace = userPlace || singleSelectedCard.birthPlace;
    const finalExisting = useExisting
      ? useExisting
      : singleSelectedCard && singleSelectedCard.useExisting
      ? singleSelectedCard.useExisting
      : false;
    console.log("finalExisting", finalExisting);

    console.log("finalExisting:", finalExisting);

    try {
      const response = await vasthuUrl.post(
        "astroCustomerDetailsForPersonal",
        {
          userId: userId,
          to_Id: consultantuuiId,
          userName: finalUserName,
          userBirthstate: finalUserPlace,
          birthTime: finalTimeValue,
          birthDate: finalDateValue,
          useExisting: finalExisting,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("Response:", response.data);
      alert(response.data.message || "Successfully Uploaded Your Details!");

      setMessageType("success");

      // Reset fields
      setUserName("");
      setUserPlace("");
      setDateValue("");
      setTimeValue("");

      // Redirect after delay
      startCountdown();
    } catch (error) {
      console.error("Error in addPersonalConsultationDetails:", error);
      alert("An error occurred. Please try again.");
      setMessageType("error");
    }
  };

  const formatDate = (date) => {
    try {
      return format(date, "d MMM yyyy");
    } catch (error) {
      console.error("Error formatting date:", error.message);
      return "";
    }
  };

  const formatTime = (timeString) => {
    if (!timeString) return "00:00 AM";

    try {
      const parsedTime = parse(timeString, "HH:mm:ss", new Date());

      return format(parsedTime, "h:mm a");
    } catch (error) {
      console.error("Error formatting time:", error.message);
      return "00:00 AM";
    }
  };

  useEffect(() => {
    console.log("Updated State:", { singleSelectedCard, singleForm });
  }, [singleSelectedCard, singleForm]);

  const backgroundColor = selectedOption === "Personal" ? "#FFD700" : "#90EE90";

  useEffect(() => {
    if (userDetailsModal > 0) {
      openUserDetailModal();
    }
    console.log("userDetailsModal", userDetailsModal);
  }, [userDetailsModal]);

  const [count, setCount] = useState(0);
  const [isCounting, setIsCounting] = useState(false);
  const [showCountDownModal, setShowCountDownModal] = useState(false);

  useEffect(() => {
    if (isCounting && count > 0) {
      const timer = setInterval(() => {
        setCount((prev) => prev - 1);
      }, 1000);

      return () => clearInterval(timer);
    } else if (count === 0) {
      setIsCounting(false);
    }
  }, [isCounting, count]);

  const startCountdown = () => {
    const consultantType = window.sessionStorage.getItem("consultantType");
    const consultantId = window.sessionStorage.getItem("consultantId");
    const details = window.sessionStorage.getItem("details");
    console.log("consultantId", consultantId);
    // setCount(20);
    setCount(15);
    setIsCounting(true);
    setShowCountDownModal(true);
    setTimeout(() => {
      if (consultantType == "Chat") {
        handleChat();
        console.log("handleChat");
      } else if (consultantType == "freeChat") {
        handleFreeChat();
        console.log("handleFreeChat");
      }
    }, 15000);
  };

  const closeModals = () => {
    setShowCountDownModal(false);
    setIsCounting(false);
  };

  return (
    <div>
      <Toast msg={message} type={messageType} trigger={toastTrigger} />

      <Modal
        show={chatUserDetailsModel}
        backdrop="static"
        keyboard={false}
        onHide={handleUserDetailesCloseModel}
        className="all_border"
        centered
        fullscreen
      >
        <Modal.Header
          handleUserDetailesCloseModel
          closeButton
          className="all_background"
        ></Modal.Header>
        <Modal.Body>
          <Container>
            <Row>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  gap: "20px",
                  padding: "20px",
                }}
              >
                <div
                  style={{
                    padding: "10px",
                    borderRadius: "10px",
                    backgroundColor:
                      selectedOption === "Personal" ? "#FFC33B" : "#fff",
                    transition: "background-color 0.3s ease",
                    cursor: "pointer",
                    display: "flex",
                  }}
                  onClick={() => setSelectedOption("Personal")}
                >
                  <input
                    type="radio"
                    name="PaymentOption"
                    value="Personal"
                    checked={selectedOption === "Personal"}
                    style={{ marginRight: "5px" }}
                    onChange={() => setSelectedOption("Personal")}
                  />
                  <label>{t("USR.PRSNL.CONSTATION")}</label>
                </div>

                <div
                  style={{
                    padding: "10px",
                    borderRadius: "10px",
                    backgroundColor:
                      selectedOption === "Matching" ? "#FFC33B" : "#fff",
                    transition: "background-color 0.3s ease",
                    cursor: "pointer",
                    display: "flex",
                  }}
                  onClick={() => setSelectedOption("Matching")}
                >
                  <input
                    type="radio"
                    name="PaymentOption"
                    value="Matching"
                    checked={selectedOption === "Matching"}
                    style={{ marginRight: "5px" }}
                    onChange={() => setSelectedOption("Matching")}
                  />
                  <label style={{ display: "flex", alignItems: "center" }}>
                    {t("USER.MATCHING")}
                  </label>
                </div>
              </div>

              {selectedOption == "Personal" ? (
                <>
                  {/* {savePersonalDetailes && savePersonalDetailes.length > 0 ? ( */}
                  {savePersonalDetailes ? (
                    <>
                      <center style={{ color: "red" }}>
                        <h4>{t("USR.CHAT.TONE.ALT.MSG")}</h4>
                      </center>
                      <Row>
                        {/* {savePersonalDetailes.map((i, j) => ( */}
                        <Col
                          // key={j}
                          className="d-flex flex-row"
                          sm={12}
                          md={8}
                          lg={6}
                        >
                          <input
                            type="radio"
                            name="singleSelection"
                            style={{ marginRight: "5px" }}
                            onChange={() => {
                              setSingleForm(false);
                              setSingleSelectedCard(savePersonalDetailes);
                              handleSelection(savePersonalDetailes, "single");
                            }}
                            checked={
                              singleSelectedCard &&
                              singleSelectedCard.name ===
                                savePersonalDetailes.userName
                            }
                          />
                          <Card
                            className="all_border"
                            style={{
                              width: "100%",
                              marginBottom: "10px",
                              backgroundColor: "antiquewhite",
                            }}
                          >
                            <Card.Body>
                              <Card.Title>
                                {t("TXT.NM.LO")}:{" "}
                                {savePersonalDetailes.userName}
                              </Card.Title>
                              <Card.Title>
                                {t("USR.DOB.SR")}:{" "}
                                {formatDate(
                                  new Date(savePersonalDetailes.birthDate)
                                )}
                              </Card.Title>
                              <Card.Title>
                                {t("USR.CON.SCH.USR.BIR.TIM")}:{" "}
                                {formatTime(savePersonalDetailes.birthTime)}
                              </Card.Title>
                              <Card.Title>
                                {t("USR.CON.SCH.USR.BIR.PLA")}:{" "}
                                {savePersonalDetailes.userBirthstate}
                              </Card.Title>
                            </Card.Body>
                          </Card>
                        </Col>
                        {/* ))} */}

                        <div className="d-flex justify-content-end">
                          {!singleForm && (
                            <Button
                              className="all_btn"
                              onClick={() => {
                                console.log("Button Clicked!");
                                setSingleSelectedCard(null);
                                setSingleForm(true);
                                setUserName("");
                                setDateValue(null);
                                setTimeValue(null);
                                setUserPlace("");
                                console.log("Updated State:", {
                                  singleSelectedCard,
                                  singleForm,
                                  userName,
                                  dateValue,
                                  timeValue,
                                  userPlace,
                                });
                              }}
                            >
                              {t("USR.ADD.NEW.BTN")}
                            </Button>
                          )}
                        </div>

                        {singleSelectedCard && (
                          <React.Fragment>
                            <Col sm={12} md={8} lg={6}>
                              <Card
                                style={{
                                  border: "2px solid green",
                                  marginTop: "20px",
                                  padding: "5px",
                                  backgroundColor: "#daefda",
                                }}
                              >
                                <h4>{t("USR.DETAILES")}:</h4>
                                <p>
                                  <strong>{t("TXT.NM.LO")}:</strong>{" "}
                                  {singleSelectedCard.name}
                                </p>
                                <p>
                                  <strong>{t("USR.DOB.SR")}:</strong>{" "}
                                  {singleSelectedCard.birthDate}
                                </p>
                                <p>
                                  <strong>
                                    {t("USR.CON.SCH.USR.BIR.TIM")}:
                                  </strong>{" "}
                                  {singleSelectedCard.birthTime}
                                </p>
                                <p>
                                  <strong>
                                    {t("USR.CON.SCH.USR.BIR.PLA")}:
                                  </strong>{" "}
                                  {singleSelectedCard.birthPlace}
                                </p>
                              </Card>
                            </Col>
                          </React.Fragment>
                        )}
                      </Row>
                    </>
                  ) : null}

                  {/* //personal add form  */}
                  {singleForm && (
                    <Row className="d-flex justify-content-center all_border">
                      <Col sm={12} md={8} lg={4} className="mt-3">
                        <Card className="all_border">
                          <Card.Header className="all_background" as="h5">
                            <center>{t("USR.PRSNL.CONSTATION")}</center>
                          </Card.Header>
                          <Card.Body>
                            <Form className="mt-2">
                              <Form.Group
                                className="mb-2"
                                style={{ textAlign: "start" }}
                              >
                                <Form.Label
                                  style={{
                                    fontSize: 20,
                                    fontWeight: "bold",
                                  }}
                                >
                                  {t("TXT.NM.LO")}
                                </Form.Label>
                                <Form.Control
                                  type="text"
                                  value={userName}
                                  required
                                  className="form_feild"
                                  placeholder={t("USR.VSH.HFTAB.HO.PH")}
                                  onChange={(e) => {
                                    let input = e.target.value;
                                    input = input.replace(/^([^A-Za-z])/, "");
                                    input = input.replace(/[^A-Za-z0-9]/g, "");
                                    console.log(input);
                                    setUserName(input);
                                  }}
                                />
                              </Form.Group>
                              <Form.Group
                                className="mb-2"
                                style={{ textAlign: "start" }}
                              >
                                <Form.Label
                                  style={{
                                    fontSize: 20,
                                    fontWeight: "bold",
                                  }}
                                >
                                  {t("USR.CON.SCH.USR.BIR.DAT")}
                                </Form.Label>
                                <br />
                                <div className="datePicker_booking">
                                  <DatePicker
                                    value={dateValue}
                                    maxDate={new Date()}
                                    onChange={handleDateChange}
                                    format="dd-MM-yy"
                                    className="form_feild"
                                    style={{ backgroundColor: "#ffb33e" }}
                                  />
                                </div>
                              </Form.Group>
                              <Form.Group
                                className="mb-2"
                                style={{ textAlign: "start" }}
                              >
                                <Form.Label
                                  style={{
                                    fontSize: 20,
                                    fontWeight: "bold",
                                  }}
                                >
                                  {t("USR.CON.SCH.USR.BIR.TIM")}
                                </Form.Label>
                                <br />
                                <TimePicker
                                  className="form_feild"
                                  value={
                                    timeValue
                                      ? dayjs(timeValue, "hh:mm A")
                                      : null
                                  }
                                  onChange={(time) =>
                                    handleTimeChange("general", time)
                                  }
                                  disabledTime={() => ({
                                    disabledHours: getDisabledHours,
                                    disabledMinutes: getDisabledMinutes,
                                  })}
                                  format="hh:mm A"
                                  use12Hours
                                  showNow={false}
                                  getPopupContainer={(trigger) =>
                                    trigger.parentNode
                                  }
                                  style={{
                                    width: "100%",
                                    height: "38px",
                                    borderRadius: "5px",
                                  }}
                                />
                              </Form.Group>
                              <Form.Group
                                className="mb-2"
                                style={{ textAlign: "start" }}
                              >
                                <Form.Label
                                  style={{
                                    fontSize: 20,
                                    fontWeight: "bold",
                                  }}
                                >
                                  {t("USR.CON.SCH.USR.BIR.PLA")}
                                </Form.Label>
                                <Form.Control
                                  type="text"
                                  value={userPlace}
                                  className="form_feild"
                                  placeholder={t("USR.ENTER.BRTH.PLC")}
                                  onChange={(e) => {
                                    let input = e.target.value;
                                    input = input.replace(/^([^A-Za-z])/, "");
                                    input = input.replace(/[^A-Za-z0-9]/g, "");
                                    console.log(input);
                                    setUserPlace(input);
                                  }}
                                />
                              </Form.Group>
                            </Form>
                          </Card.Body>
                        </Card>
                      </Col>
                    </Row>
                  )}

                  {singleSelectedCard || singleForm ? (
                    <Row className="d-flex mt-4">
                      <Col className="d-flex justify-content-end">
                        <Button
                          className="all_btn"
                          onClick={() => {
                            handleButtonClick(false);
                          }}
                          disabled={
                            !singleSelectedCard &&
                            (!userName ||
                              !dateValue ||
                              !timeValue ||
                              !userPlace)
                          }
                        >
                          {t("USR.HOM.BTN.SUB")}
                        </Button>
                      </Col>
                    </Row>
                  ) : null}
                </>
              ) : (
                <>
                  {saveMatchingDetailes ? (
                    <>
                      <Row className="d-flex justify-content-center all_border"></Row>
                      <>
                        <center style={{ color: "red" }}>
                          <h4>{t("USR.MATC.ALT.MSG")}</h4>
                        </center>
                        <Row className="d-flex flex-row justify-content-center all_border">
                          {/* {saveMatchingDetailes.map((i, j) => ( */}
                          <>
                            <Col
                              // className="d-flex flex-row p-0"
                              xs={12}
                              // sm={12}
                              md={6}
                              lg={6}
                            >
                              <center>{t("USR.MAT.GROOM")}</center>
                              <div className="d-flex flex-row p-0">
                                <input
                                  type="radio"
                                  name="maleSelection"
                                  style={{ marginRight: "5px" }}
                                  onChange={() => {
                                    setShowForm(false);
                                    handleSelection(
                                      saveMatchingDetailes,
                                      "male"
                                    );
                                  }}
                                  checked={
                                    maleselectedCard &&
                                    maleselectedCard.name ===
                                      saveMatchingDetailes.maleUserName
                                  }
                                />
                                <Card
                                  // key={j}
                                  style={{
                                    width: "100%",
                                    marginBottom: "10px",
                                    backgroundColor: "antiquewhite",
                                  }}
                                  className="all_border"
                                >
                                  <Card.Body>
                                    <Card.Title className="detail_card_title">
                                      {t("TXT.NM.LO")}:{" "}
                                      {saveMatchingDetailes.maleUserName}
                                    </Card.Title>
                                    <Card.Title className="detail_card_title">
                                      {t("USR.DOB.SR")}:{" "}
                                      {formatDate(
                                        new Date(
                                          saveMatchingDetailes.maleBirthDate
                                        )
                                      )}
                                    </Card.Title>
                                    <Card.Title className="detail_card_title">
                                      {t("USR.CON.SCH.USR.BIR.TIM")}:{" "}
                                      {formatTime(
                                        saveMatchingDetailes.maleBirthTime
                                      )}
                                    </Card.Title>
                                    <Card.Title className="detail_card_title">
                                      {t("USR.CON.SCH.USR.BIR.PLA")}:{" "}
                                      {saveMatchingDetailes.maleBirthPlace}
                                    </Card.Title>
                                  </Card.Body>
                                </Card>
                              </div>
                            </Col>
                            <Col
                              // className="d-flex flex-row p-0"
                              xs={12}
                              // sm={12}
                              md={6}
                              lg={6}
                            >
                              <center>{t("USR.ADD.BRIDE")}</center>
                              <div className="d-flex flex-row p-0">
                                <input
                                  type="radio"
                                  name="femaleSelection"
                                  style={{ marginRight: "5px" }}
                                  onChange={() => {
                                    handleSelection(
                                      saveMatchingDetailes,
                                      "female"
                                    );
                                    setShowFemaleForm(false);
                                  }}
                                  checked={
                                    femaleSelectedCard &&
                                    femaleSelectedCard.name ===
                                      saveMatchingDetailes.femaleUserName
                                  }
                                />
                                <Card
                                  style={{
                                    width: "100%",
                                    marginBottom: "10px",
                                    backgroundColor: "antiquewhite",
                                  }}
                                  className="all_border"
                                >
                                  <Card.Body>
                                    <Card.Title className="detail_card_title">
                                      {t("TXT.NM.LO")}:{" "}
                                      {saveMatchingDetailes.femaleUserName}
                                    </Card.Title>
                                    <Card.Title className="detail_card_title">
                                      {t("USR.DOB.SR")}:{" "}
                                      {formatDate(
                                        new Date(
                                          saveMatchingDetailes.femaleBirthDate
                                        )
                                      )}
                                    </Card.Title>
                                    <Card.Title className="detail_card_title">
                                      {t("USR.CON.SCH.USR.BIR.TIM")}:{" "}
                                      {formatTime(
                                        saveMatchingDetailes.femaleBirthTime
                                      )}
                                    </Card.Title>
                                    <Card.Title className="detail_card_title">
                                      {t("USR.CON.SCH.USR.BIR.PLA")}:{" "}
                                      {saveMatchingDetailes.femaleBirthPlace}
                                    </Card.Title>
                                  </Card.Body>
                                </Card>
                              </div>
                            </Col>
                          </>
                          {/* ))} */}

                          {/* Add male & Add female button */}
                          <div
                            className="d-flex flex-row justify-content-around"
                            style={{ gap: "5px" }}
                          >
                            {!showForm && (
                              <Button
                                className="all_btn detail_card_title"
                                onClick={() => {
                                  //  setMaleSelectedCard(null);
                                  setMaleSelectedCard((prev) =>
                                    prev !== null ? null : prev
                                  );
                                  setShowForm(true);
                                  console.log("Button Clicked!");
                                  setMaleUserName("");
                                  setMaleDateValue(null);
                                  setMaleTimeValue(null);
                                  setMaleUserPlace("");
                                  setShowAddMaleButton(false);
                                  console.log("Updated State:", {
                                    maleselectedCard,
                                    showForm,
                                    maleUserName,
                                    maledateValue,
                                    maletimeValue,
                                    maleuserPlace,
                                  });
                                }}
                              >
                                {/* Add Male */}
                                <FaMale className="detail_card_title" />
                                {t("USR.MAT.GROOM")}
                              </Button>
                            )}

                            {!showFemaleForm && (
                              <Button
                                className="all_btn detail_card_title"
                                onClick={() => {
                                  setFemaleSelectedCard(null);
                                  setShowFemaleForm(true);
                                  console.log("Button Clicked!");
                                  setFeUserName("");
                                  setFeDateValue(null);
                                  setFeTimeValue(null);
                                  setFeUserPlace("");
                                  setShowAddFemaleButton(false);
                                  console.log("Updated State:", {
                                    femaleSelectedCard,
                                    showFemaleForm,
                                    feuserName,
                                    fedateValue,
                                    fetimeValue,
                                    feuserPlace,
                                  });
                                }}
                              >
                                {/* Add Female */}
                                <FaFemale className="detail_card_title" />
                                {t("USR.ADD.BRIDE")}
                              </Button>
                            )}
                          </div>

                          {maleselectedCard && (
                            <Col sm={12} md={8} lg={6}>
                              <Card
                                style={{
                                  border: "2px solid green",
                                  marginTop: "20px",
                                  padding: "5px",
                                  backgroundColor: "#daefda",
                                }}
                              >
                                <h4>{t("USR.GROOM.DETAILES")}:</h4>
                                <p>
                                  <strong>{t("TXT.NM.LO")}:</strong>{" "}
                                  {maleselectedCard.name}
                                </p>
                                <p>
                                  <strong>{t("USR.DOB.SR")}:</strong>{" "}
                                  {maleselectedCard.birthDate}
                                </p>
                                <p>
                                  <strong>
                                    {t("USR.CON.SCH.USR.BIR.TIM")}:
                                  </strong>{" "}
                                  {maleselectedCard.birthTime}
                                </p>
                                <p>
                                  <strong>
                                    {t("USR.CON.SCH.USR.BIR.PLA")}:
                                  </strong>{" "}
                                  {maleselectedCard.birthPlace}
                                </p>
                              </Card>
                            </Col>
                          )}

                          {femaleSelectedCard && (
                            <Col sm={12} md={8} lg={6}>
                              <Card
                                style={{
                                  border: "2px solid green",
                                  marginTop: "20px",
                                  padding: "5px",
                                  backgroundColor: "#daefda",
                                }}
                              >
                                <h4>{t("USR.BRIDE.DETAILES")}:</h4>
                                <p>
                                  <strong>{t("TXT.NM.LO")}:</strong>{" "}
                                  {femaleSelectedCard.name}
                                </p>
                                <p>
                                  <strong>{t("USR.DOB.SR")}:</strong>{" "}
                                  {femaleSelectedCard.birthDate}
                                </p>
                                <p>
                                  <strong>
                                    {t("USR.CON.SCH.USR.BIR.TIM")}:
                                  </strong>{" "}
                                  {femaleSelectedCard.birthTime}
                                </p>
                                <p>
                                  <strong>
                                    {t("USR.CON.SCH.USR.BIR.PLA")}:
                                  </strong>{" "}
                                  {femaleSelectedCard.birthPlace}
                                </p>
                              </Card>
                            </Col>
                          )}
                        </Row>
                      </>
                    </>
                  ) : null}

                  <span className="d-flex justify-content-around p-3">
                    {showForm && (
                      <Col sm={12} md={8} lg={4} className="mt-3">
                        <Card className="all_border">
                          <Card.Header className="all_background" as="h5">
                            <center>{t("USR.GROOM")}</center>
                          </Card.Header>
                          <Card.Body>
                            <Form className="mt-2">
                              <Form.Group
                                className="mb-2"
                                style={{ textAlign: "start" }}
                              >
                                <Form.Label
                                  style={{
                                    fontSize: 20,
                                    fontWeight: "bold",
                                  }}
                                >
                                  {t("TXT.NM.LO")}
                                </Form.Label>
                                <Form.Control
                                  type="text"
                                  value={maleUserName}
                                  required
                                  className="form_feild"
                                  placeholder={t("USR.VSH.HFTAB.HO.PH")}
                                  onChange={(e) => {
                                    let input = e.target.value.replace(
                                      /[^A-Za-z0-9]/g,
                                      ""
                                    );
                                    setMaleUserName(input);
                                  }}
                                />
                              </Form.Group>

                              <Form.Group
                                className="mb-2"
                                style={{ textAlign: "start" }}
                              >
                                <Form.Label
                                  style={{
                                    fontSize: 20,
                                    fontWeight: "bold",
                                  }}
                                >
                                  {t("USR.GENDER")}
                                </Form.Label>
                                <Form.Control
                                  type="text"
                                  value={
                                    gender ? t("USR.MALE") : t("USR.FEMALE")
                                  }
                                  className="form_feild"
                                  disabled
                                />
                              </Form.Group>
                              <Form.Group
                                className="mb-2"
                                style={{ textAlign: "start" }}
                              >
                                <Form.Label
                                  style={{
                                    fontSize: 20,
                                    fontWeight: "bold",
                                  }}
                                >
                                  {t("USR.CON.SCH.USR.BIR.DAT")}
                                </Form.Label>
                                <br />
                                <div className="datePicker_booking">
                                  <DatePicker
                                    value={maledateValue}
                                    maxDate={new Date()}
                                    onChange={handleMaleDateChange}
                                    format="dd-MM-yy"
                                    className="form_feild"
                                    style={{ backgroundColor: "#ffb33e" }}
                                  />
                                </div>
                              </Form.Group>

                              <Form.Group
                                className="mb-2"
                                style={{ textAlign: "start" }}
                              >
                                <Form.Label
                                  style={{
                                    fontSize: 20,
                                    fontWeight: "bold",
                                  }}
                                >
                                  {t("USR.CON.SCH.USR.BIR.TIM")}
                                </Form.Label>
                                <br />
                                <TimePicker
                                  value={
                                    maletimeValue
                                      ? dayjs(maletimeValue, "hh:mm A")
                                      : null
                                  }
                                  onChange={(time) =>
                                    handleTimeChange("male", time)
                                  }
                                  disabledTime={() => ({
                                    disabledHours: getDisabledHours,
                                    disabledMinutes: getDisabledMinutes,
                                  })}
                                  format="hh:mm A"
                                  use12Hours
                                  showNow={false}
                                  getPopupContainer={(trigger) =>
                                    trigger.parentNode
                                  }
                                  status="warning"
                                  style={{
                                    width: "100%",
                                    height: "38px",
                                    borderRadius: "5px",
                                  }}
                                />
                              </Form.Group>

                              <Form.Group
                                className="mb-2"
                                style={{ textAlign: "start" }}
                              >
                                <Form.Label
                                  style={{
                                    fontSize: 20,
                                    fontWeight: "bold",
                                  }}
                                >
                                  {t("USR.CON.SCH.USR.BIR.PLA")}
                                </Form.Label>
                                <Form.Control
                                  type="text"
                                  value={maleuserPlace}
                                  className="form_feild"
                                  placeholder={t("USR.ENTER.BRTH.PLC")}
                                  onChange={(e) => {
                                    let input = e.target.value.replace(
                                      /[^A-Za-z0-9]/g,
                                      ""
                                    );
                                    setMaleUserPlace(input);
                                  }}
                                />
                              </Form.Group>
                            </Form>
                          </Card.Body>
                        </Card>
                      </Col>
                    )}

                    {/* Female add Form */}
                    {showFemaleForm && (
                      <Col sm={12} md={8} lg={4} className="mt-3">
                        <Card className="all_border">
                          <Card.Header className="all_background" as="h5">
                            <center>{t("USR.BRIDE")}</center>
                          </Card.Header>
                          <Card.Body>
                            <Form className="mt-2">
                              <Form.Group
                                className="mb-2"
                                style={{ textAlign: "start" }}
                              >
                                <Form.Label
                                  style={{
                                    fontSize: 20,
                                    fontWeight: "bold",
                                  }}
                                >
                                  {t("TXT.NM.LO")}
                                </Form.Label>
                                <Form.Control
                                  type="text"
                                  value={feuserName}
                                  required
                                  className="form_feild"
                                  placeholder={t("USR.VSH.HFTAB.HO.PH")}
                                  onChange={(e) => {
                                    let input = e.target.value;
                                    input = input.replace(/^([^A-Za-z])/, "");
                                    input = input.replace(/[^A-Za-z0-9]/g, "");
                                    console.log(input);
                                    setFeUserName(input);
                                  }}
                                />
                              </Form.Group>
                              <Form.Group
                                className="mb-2"
                                style={{ textAlign: "start" }}
                              >
                                <Form.Label
                                  style={{
                                    fontSize: 20,
                                    fontWeight: "bold",
                                  }}
                                >
                                  {t("USR.GENDER")}
                                </Form.Label>
                                <Form.Control
                                  type="text"
                                  value={
                                    !gender ? t("USR.MALE") : t("USR.FEMALE")
                                  }
                                  className="form_feild"
                                  disabled
                                />
                              </Form.Group>
                              <Form.Group
                                className="mb-2"
                                style={{ textAlign: "start" }}
                              >
                                <Form.Label
                                  style={{
                                    fontSize: 20,
                                    fontWeight: "bold",
                                  }}
                                >
                                  {t("USR.CON.SCH.USR.BIR.DAT")}
                                </Form.Label>
                                <br />
                                <div className="datePicker_booking">
                                  <DatePicker
                                    value={fedateValue}
                                    maxDate={new Date()}
                                    onChange={handleFemaleDateChange}
                                    format="dd-MM-yy"
                                    className="form_feild"
                                    style={{ backgroundColor: "#ffb33e" }}
                                  />
                                </div>
                              </Form.Group>
                              <Form.Group
                                className="mb-2"
                                style={{ textAlign: "start" }}
                              >
                                <Form.Label
                                  style={{
                                    fontSize: 20,
                                    fontWeight: "bold",
                                  }}
                                >
                                  {t("USR.CON.SCH.USR.BIR.TIM")}
                                </Form.Label>
                                <br />
                                <TimePicker
                                  value={
                                    fetimeValue
                                      ? dayjs(fetimeValue, "hh:mm A")
                                      : null
                                  }
                                  onChange={(time) =>
                                    handleTimeChange("female", time)
                                  }
                                  format="hh:mm A"
                                  use12Hours
                                  showNow={false}
                                  getPopupContainer={(trigger) =>
                                    trigger.parentNode
                                  }
                                  disabledTime={() => ({
                                    disabledHours: getDisabledHours,
                                    disabledMinutes: getDisabledMinutes,
                                  })}
                                  status="warning"
                                  style={{
                                    width: "100%",
                                    height: "38px",
                                    borderRadius: "5px",
                                  }}
                                />
                              </Form.Group>
                              <Form.Group
                                className="mb-2"
                                style={{ textAlign: "start" }}
                              >
                                <Form.Label
                                  style={{
                                    fontSize: 20,
                                    fontWeight: "bold",
                                  }}
                                >
                                  {t("USR.CON.SCH.USR.BIR.PLA")}
                                </Form.Label>
                                <Form.Control
                                  type="text"
                                  value={feuserPlace}
                                  className="form_feild"
                                  placeholder={t("USR.ENTER.BRTH.PLC")}
                                  onChange={(e) => {
                                    let input = e.target.value;
                                    input = input.replace(/^([^A-Za-z])/, "");
                                    input = input.replace(/[^A-Za-z0-9]/g, "");
                                    console.log(input);
                                    setFeUserPlace(input);
                                  }}
                                />
                              </Form.Group>
                            </Form>
                          </Card.Body>
                        </Card>
                      </Col>
                    )}
                  </span>

                  {(maleselectedCard || showForm) &&
                  (femaleSelectedCard || showFemaleForm) ? (
                    <div className="d-flex justify-content-end">
                      <Button
                        className="all_btn1"
                        onClick={() => {
                          console.log("Submit okkk button clicked");
                          handleAddMatchingDetailes(false);
                        }}
                      >
                        {t("USR.HOM.BTN.SUB")}
                      </Button>
                    </div>
                  ) : null}
                </>
              )}
            </Row>
          </Container>
        </Modal.Body>
      </Modal>

      <Modal
        show={showCountDownModal}
        backdrop="static"
        keyboard={false}
        onHide={closeModals}
        className="all_border"
        centered
      >
        <Row>
          <Col xs={12} sm={12} md={12} className="text-center">
            <h2 className="countdown_tone_text p-4">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100px",
                  width: "100px",
                  margin: "auto",
                }}
              >
                <Spinner
                  animation="border"
                  style={{ width: "4rem", height: "4rem", color: "#239414" }}
                />
              </div>
              <center>Connecting in {count} seconds...</center>
            </h2>
          </Col>
        </Row>
      </Modal>
    </div>
  );
}

export default UserDetailModal;
